export default 
{
	"progressbar-page-title": "Pagina",
	"name-suffix": "Suffisso",
	"fileupload-desc-progress-message": "Caricamento {progress}",
	"required-if-greater-than-or-equal": "{property} è richiesto quando {compareSource} è maggiore o uguale a {compareValue}.",
	"powered-by-cognito": "Modulo fornito da Cognito Forms.",
	"form-name-default": "Senza titolo",
	"field-choice-defaults": "Prima Scelta|Seconda Scelta|Terza Scelta",
	"additional-fee-default-label": "Commissione aggiuntiva",
	"authenticated-save-and-resume-email-dialog": "Invia un collegamento via email e torna al modulo per completare l\u0027invio.",
	"string-length-between": "{property} deve essere tra {min} e {max} caratteri.",
	"update-button-text": "Aggiornare",
	"address-zip-code-invalid": "Zip Code deve essere formattata come #####-####.",
	"required-if-greater-than": "{property} è richiesto quando {compareSource} è maggiore di {compareValue}.",
	"compare-before": "{property} deve essere prima di {compareSource}.",
	"compare-after": "{property} deve essere dopo {compareSource}.",
	"unsupported-browser-message": "Oh No! Si sta utilizzando un browser non supportato. {a}Fai clic qui {/} per l\u0027aggiornamento.",
	"shared-entry-email-subject": "Link Condivisa",
	"send-button-text": "Inviare",
	"venmo-help-text": "Collegati a Venmo per procedere con il pagamento.",
	"field-repeatingsection-item-label": "Articolo",
	"save-and-resume-email-not-sent-message": "C\u0027era un problema.",
	"credit-card-cvv": "CVV",
	"range-at-least": "{property} deve essere almeno {min}.",
	"entry-notification-full-entry-detail-link": "Mostra dettagli voce completo a cognitoforms.com.",
	"element-label-website": "Sito Web",
	"element-label-signature": "Firma",
	"paypal-help-text": "Collegati a PayPal per procedere con il pagamento.",
	"card-on-file-agreement-validation": "Devi accettare di salvare la tua carta per le transazioni future.",
	"marketing-button-4": "Costruisci Il Tuo Gratuitamente",
	"field-datepicker-now": "Ora",
	"save-and-resume-email-resume-button": "Riprendi ora",
	"field-datepicker-next-month": "Mese successivo",
	"quantity-remaining-text": "rimanente",
	"payment-declined": "Pagamento rifiutato",
	"required-if-before": "{property} è richiesto quando {compareSource} è prima {compareValue}.",
	"this-comma-that": "{0}, {1}",
	"compare-less-than": "{property} deve essere minore di {compareSource}.",
	"entry-admin-link": "",
	"required-many": "{0} sono richiesti.",
	"save-and-resume-multiple-days-expiration-email-message": "Utilizza il pulsante qui sotto per tornare al tuo modulo entro i prossimi {days} giorni per completare l\u0027invio.",
	"string-length-at-least": "{property} deve essere almeno {min} caratteri.",
	"credit-card-number": "Numero Di Carta Di Credito",
	"range-on-or-before": "{property} deve essere prima {max} o.",
	"required-one": "{0} è richiesto.",
	"fileupload-max-file-count-exceeded-message": "Solo {maxFileCount} può essere caricato.",
	"order-transaction-details-header": "Dettagli transazione",
	"field-spinner-increase": "Aumentare",
	"payment-processing-fees": "Tasse di elaborazione",
	"payment": "Pagamento",
	"field-choice-other-fill-in": "Altro",
	"shared-entry-email-message": "Una voce è stata condivisa con voi.",
	"shared-entry-workflow-link": "Visualizza il modulo.",
	"required-if-exists": "{property} è necessaria quando viene specificato {compareSource}.",
	"concurrent-conflict-toast-message": "L\u0027invio non è riuscito perché le informazioni sul modulo sono cambiate. Si prega di verificare e riprovare.",
	"secured-by-paypal": "Protetto da",
	"range-on-or-after": "{property} deve essere a partire da {min}.",
	"payment-amount-due": "Importo dovuto",
	"required-name-first-and-last": "Nome e Cognome sono richiesti.",
	"required": "{property} è richiesto.",
	"string-format-alphabetic": "{property} deve contenere solo lettere.",
	"quantity-limit": "{property} quantità superata.",
	"field-spinner-decrease": "Diminuire",
	"field-repeatingsection-add-link-text": "Aggiungi",
	"fileupload-max-size-exceeded-message": "Solo file più piccoli di {maxSize} MB può essere caricato.",
	"credit-card-expiration": "MM/YY",
	"field-signature-notcaptured": "Non Catturato",
	"field-ratingscale-satisfied-unsatisfied-label": "Soddisfatto/Insoddisfatto",
	"range-between": "{property} deve essere tra {min} e {max}.",
	"field-ratingscale-agree-disagree-label": "Accetto/disaccordo",
	"back-button-text": "Indietro",
	"address-country": "Paese",
	"order-not-found": "Nessuna informazione di ordine trovata.",
	"field-ratingscale-satisfied-unsatisfied-options": "Molto insoddisfatto|insoddisfatto|neutro|soddisfatto|molto soddisfatto",
	"entry-notification-entry-details-header": "Voce dettagli",
	"FALSE": "FALSO",
	"compare-greater-than-or-equal": "{property} deve essere maggiore o uguale a {compareSource}.",
	"receipt-notification-order-details-desc-header": "Descrizione",
	"order-method-label": "Metodo",
	"order-total-label": "Totale ordine",
	"invalid-shared-link": "Valido Collegamento Condiviso",
	"fileupload-zero-byte-file-message": "Zero file byte Non possono essere caricati.",
	"range-at-most": "{property} deve essere al massimo di {max}.",
	"format-integer": "####",
	"order-date-label": "Data",
	"fileupload-dropzone-message": "o trascinare i file qui.",
	"shared-entry-view-link": "Visualizzare la voce condivisa.",
	"format-currency": "#.###,## €",
	"string-length-at-most": "{property} deve essere al massimo {max} caratteri.",
	"entry-confirmation-footer-tagline": "Crea le tue forme potenti con il pagamento a",
	"submit-button-text": "Invia",
	"marketing-msg": "Creare facilmente forme potenti.",
	"required-if-on-or-after": "{property} è richiesto quando {compareSource} è acceso o dopo {compareValue}.",
	"card-on-file-agreement": "Accetto di salvare la mia carta per le transazioni future.",
	"signature-draw": "disegnare",
	"address-zip-code": "Zip Code",
	"compare-on-or-after": "{property} deve essere o dopo {compareSource}.",
	"required-if-less-than-or-equal": "{property} è richiesto quando {compareSource} è minore o uguale {compareValue}.",
	"field-datepicker-next-year": "Anno successivo",
	"change-button": "modificare",
	"fileupload-desc-size-in-bytes-message": "{size} byte",
	"card-tab": "Carta",
	"order-billing-info-header": "Informazioni di fatturazione",
	"entry-email-view-details-text": "Mostra piena voce a CognitoForms.com.",
	"save-and-resume-one-day-expiration-email-message": "Utilizza il pulsante qui sotto per tornare al tuo modulo entro il giorno successivo per completare l\u0027invio.",
	"credit-card-authentication-failed": "Autenticazione non riuscita della carta.",
	"compare-less-than-or-equal": "{property} deve essere minore o uguale a {compareSource}.",
	"receipt-notification-order-details-balance-due": "Scaduto",
	"save-and-resume-multiple-days-expiration-message": "Copiare o e-mail il link qui sotto e tornare al modulo entro i prossimi {days} giorni per completare la vostra presentazione.",
	"processing-fee-calculating-message": "Calcolo",
	"receipt-notification-trx-details-method": "Metodo",
	"field-choice-no-match": "Nessuna corrispondenza",
	"fileupload-invalid-file-type-message": "Solo {allowedTypes} può essere caricati.",
	"receipt-notification-trx-details-date": "Data",
	"credit-card-authorization": "Autorizzazione della carta",
	"address-line1": "Indirizzo Linea 1",
	"required-if-not-exists": "{property} è richiesto quando {compareSource} non è specificato.",
	"required-if-not-equal": "{property} è richiesto quando {compareSource} non è {compareValue}.",
	"marketing-button-2": "Costruisci Il Tuo Gratuitamente",
	"receipt-notification-billing-info-header": "Informazioni di fatturazione",
	"required-if-after": "{property} è richiesto quando {compareSource} è dopo {compareValue}.",
	"element-label-name": "Nome",
	"required-if-equal": "{property} è richiesto quando {compareSource} è {compareValue}.",
	"connected-to-paypal": "Connesso a PayPal.",
	"people-form-email-quantity-exceeded-message": "L\u0027indirizzo email deve essere univoco.",
	"receipt-notification-order-details-subtotal": "Subtotale",
	"shared-entry-edit-link": "Modificare la voce condivisa.",
	"receipt-notification-trx-details-header": "Dettagli transazione",
	"address-city": "Città",
	"receipt-notification-order-details-amount-paid": "Importo pagato",
	"credit-card-invalid": "La carta non è valida.",
	"format-decimal": "####,##",
	"entry-notification-new-submission-text": "Hai un nuovo invio del modulo.",
	"this-and-that": "{0} e {1}",
	"field-ratingscale-good-poor-label": "Buono/Scarsa",
	"network-unavailable-message": "Rete non disponibile, riprova più tardi.",
	"dialog-close": "Chiudere",
	"string-format-alphanumeric": "{property} deve contenere solo lettere e numeri.",
	"credit-card": "Carta di credito",
	"remove-item": "Rimuovere {item}",
	"receipt-notification-order-details-price-header": "Prezzo",
	"fileupload-upload-inprogress-message": "Upload di file in corso.",
	"public-terms-of-service-link-text": "Termini del servizio",
	"save-and-resume-email-subject": "Salva e Riprendi link",
	"field-repeatingsection-remove-link-text": "Rimuovere",
	"field-ratingscale-na-label": "N/A",
	"add-item": "Aggiungi {item}",
	"field-toggle-options": "Sì/No|Vero/Falso|aperto/chiuso|Attiva/Disattiva|Read/Unread",
	"order-submit-timeout": "Elaborazione degli ordini richiede troppo tempo. Riprova piu tardi il tuo ordine.",
	"listlength-at-most": "Si prega di specificare non più di {max} {property}.",
	"shared-entry-email-view-message": "Cliccate sul link sottostante per visualizzare la voce condivisa.",
	"order-number-label": "Numero",
	"card-declined": "Carta rifiutata",
	"fileupload-default-upload-button-text": "Caricare",
	"name-prefix": "Titolo",
	"address-line2": "Indirizzo Linea 2",
	"element-label-email": "Posta elettronica",
	"field-ratingscale-good-poor-options": "Molto scarso|Scarso|Sufficiente|Buono|Molto buono",
	"next-button-text": "Avanti",
	"question": "Domanda",
	"address-postalcode": "Codice Postale / Zip Code",
	"format-with-description": "{property} deve essere formattata come {description}.",
	"field-datepicker-prev-month": "Mese precedente",
	"name": "Nome",
	"receipt-notification-order-details-total-footer": "Totale",
	"confirmation-message": "Grazie per la compilazione del modulo. La tua risposta è stata registrata.",
	"shared-entry-email-edit-message": "Cliccare sul link sottostante per modificare la voce condivisa.",
	"field-default-label": "Senza titolo",
	"required-value": "{property} deve essere {value}.",
	"name-middle": "Secondo nome",
	"fileupload-failed-upload-message": "{fileName} non riuscito a caricare.",
	"shared-entry-email-button-label": "Visualizza la voce",
	"field-datepicker-year": "",
	"element-label-phone": "Telefono",
	"TRUE": "VERO",
	"listlength-between": "Si prega di specificare tra {min} e {max} {property}.",
	"marketing-button-1": "Provalo Ora",
	"entry-submission-error-heading": "Voce elaborazione errore",
	"order-not-found-message": "Nessuna informazione di ordine trovata.",
	"format-without-description": "{property} non è formattato correttamente.",
	"name-last": "Cognome",
	"field-ratingscale-one-five-label": "Scala da 1 a 5",
	"listlength-at-least": "Specifica almeno {min} {property}.",
	"united-states": "Stati Uniti",
	"field-signature-captured": "Catturato",
	"compare-on-or-before": "{property} deve essere prima {compareSource} o.",
	"order-balance-due-label": "Scaduto",
	"required-if-less-than": "{property} è richiesto quando {compareSource} è minore di {compareValue}.",
	"credit-card-postalcode": "Codice Postale",
	"form-not-available-message": "Questa forma non è al momento disponibile.",
	"element-label-address": "Indirizzo",
	"receipt-notification-trx-details-number": "Numero",
	"public-submission-warning": "Per favore non inviare le password attraverso Cognito Forms.",
	"save-and-resume-no-expiration-email-message": "Utilizza il pulsante qui sotto per tornare al tuo modulo per completare l\u0027invio.",
	"fileupload-excluded-file-type-message": "I file di questo tipo non possono essere caricati.",
	"payment-subtotal": "Subtotale",
	"collapse": "Comprimere",
	"save-button-text": "Salva",
	"field-datepicker-prev-year": "Anno precedente",
	"signature-type": "digitare",
	"order-amount-minimum": "Importo dovuto deve essere di almeno € 1,00.",
	"string-format-numeric": "{property} deve contenere solo numeri.",
	"entry-confirmation-entry-details-header": "Voce dettagli",
	"connected-to-venmo": "Connesso a Venmo.",
	"format-percentage": "#,##%",
	"receipt-notification-header": "Ricevute",
	"clear": "Eliminare",
	"today": "Oggi",
	"required-name-last": "Cognome è richiesto.",
	"marketing-button-3": "Provalo Ora",
	"expand": "Espandere",
	"compare-greater-than": "{property} deve essere maggiore di {compareSource}.",
	"field-ratingscale-will-wont-label": "Sarà/non",
	"required-name-first": "Nome è richiesto.",
	"save-and-resume-one-day-expiration-message": "Copiare o e-mail il link qui sotto e tornare al modulo entro il giorno successivo per completare la vostra presentazione.",
	"required-asterisk": "richiesto",
	"credit-card-required": "È richiesta la carta di credito.",
	"address-state-province-region": "Stato / Provincia / Regione",
	"save-and-resume-email-sent-message": "L\u0027email è stata inviata.",
	"workflow-action": "Azione",
	"field-ratingscale-will-wont-options": "Sicuramente non sarà|probabilmente non|Non saprei|probabilmente|Sicuramente",
	"save-and-resume-email-label": "Email me il mio link:",
	"field-ratingscale-agree-disagree-options": "Completamente in disaccordo|in disaccordo|neutro|d\u0027accordo|d\u0027accordo Fortemente",
	"order-exception-order-already-paid": "Questo ordine è già stato pagato.",
	"fileupload-download-text": "Scarica",
	"address-state": "Stato",
	"allowed-values": "{property} non è nell\u0027elenco dei valori consentiti.",
	"shared-entry-workflow-email-button-label": "Apri il modulo",
	"compare-equal": "{property} deve essere lo stesso di {compareSource}.",
	"field-datepicker-clear": "Pulisci",
	"name-first": "Nome",
	"save-and-resume-message": "Il vostro progresso è stato salvato.",
	"save-and-resume-no-expiration-message": "Copiare o e-mail il link qui sotto e tornare al modulo per completare la vostra presentazione.",
	"entry-notification-view-details-text": "Visualizza dettagli",
	"order-exception-default-message": "Impossibile elaborare la transazione.",
	"public-report-abuse-link-text": "Segnala un abuso",
	"order-amount-paid": "Importo pagato",
	"element-label-default": "Senza titolo",
	"countries": "Afghanistan|Albania|Algeria|Andorra|Angola|Anguilla|Antartide|Antigua e Barbuda|Antille olandesi|Arabia Saudita|Argentina|Armenia|Aruba|Australia|Austria|Azerbaigian|Bahamas|Bahrein|Bangladesh|Barbados|Belarus|Belgio|Belize|Benin|Bermuda|Bhutan|Bolivia|Bosnia ed Erzegovina|Botswana|Brasile|Brunei Darussalam|Bulgaria|Burkina Faso|Burundi|Cambogia|Camerun|Canada|Capo Verde|Ciad|Cile|Cina|Cipro|Città del Vaticano (Santa sede)|Colombia|Comore|Congo, Repubblica of(Brazzaville)|Corea, democratica popolare \u0027 s REP (Corea del Nord)|Corea, Repubblica di (Corea del sud)|Costa Rica|Costa d\u0027Avorio|Croazia|Cuba|Danimarca|Dominica|East Timor (Timor est)|Ecuador|Egitto|El Salvador|Emirati Arabi Uniti|Eritrea|Estonia|Etiopia|Federazione russa|Figi|Filippine|Finlandia|Francia|Gabon|Gambia|Georgia|Germania|Ghana|Giamaica|Giappone|Gibilterra|Gibuti|Giordania|Gran Bretagna|Grecia|Grenada|Groenlandia|Guadalupa|Guam|Guatemala|Guiana francese|Guinea|Guinea equatoriale|Guinea-Bissau|Guyana|Haiti|Honduras|Hong Kong|India|Indonesia|Iran (Repubblica islamica)|Iraq|Irlanda|Islanda|Isola della Reunion|Isola di Man|Isola di Natale|Isole Faroe|Isole Cayman|Isole Cocos (Keeling)|Isole Cook|Isole di Wallis e Futuna|Isole Falkland|Isole Marianne settentrionali|Isole Marshall|Isole Salomone|Isole Turks e Caicos|Isole Vergini (britanniche)|Isole Vergini (US)|Israele|Italia|Kazakhstan|Kenia|Kirghizistan|Kiribati|Kosovo|Kuwait|Lao, persone \u0027 s Repubblica democratica|Lesotho|Lettonia|Libano|Liberia|Libia|Liechtenstein|Lituania|Lussemburgo|Macau|Macedonia, rappresentante della|Madagascar|Malawi|Malaysia|Maldive|Mali|Malta|Marocco|Martinica|Mauritania|Mauritius|Mayotte|Messico|Micronesia, Stati federali di|Moldova, Repubblica di|Monaco|Mongolia|Montenegro|Montserrat|Mozambico|Myanmar, in Birmania|Namibia|Nauru|Nepal|Nicaragua|Niger|Nigeria|Niue|Norvegia|Nuova Zelanda|Nuova Caledonia|Oman|Paesi Bassi|Pakistan|Palau|Panama|Papua Nuova Guinea|Paraguay|Perù|Pitcairn Island|Polinesia francese|Polonia|Portogallo|Portorico|Qatar|Regno Unito|Repubblica Ceca|Repubblica Dominicana|Repubblica Centrafricana|Repubblica democratica del Congo (Kinshasa)|Romania|Ruanda|Sahara occidentale|Saint Kitts e Nevis|Saint Lucia|Saint Vincent e Grenadine|Samoa|Samoa americane|San Marino|Santa sede|Sao Tomè e Principe|Senegal|Serbia|Seychelles|Sierra Leone|Singapore|Siria, Repubblica araba siriana|Slovacchia (Repubblica slovacca)|Slovenia|Somalia|Spagna|Sri Lanka|Stati Uniti|Sud Africa|Sud Sudan|Sudan|Suriname|Svezia|Svizzera|Swaziland|Tagikistan|Taiwan (Repubblica di Cina)|Tanzania; ufficialmente la Repubblica unita di Tanzania|Territori francesi meridionali|Territori palestinesi|Thailandia|Tibet|Timor-Leste (Timor est)|Togo|Tokelau|Tonga|Trinidad e Tobago|Tunisia|Turchia|Turkmenistan|Tuvalu|Ucraina|Uganda|Ungheria|Uruguay|Uzbekistan|Vanuatu|Venezuela|Vietnam|Yemen|Zambia|Zimbabwe",
	"name-middleinitial": "MI",
	"order-exception-empty-order": "Ordine deve contenere almeno 1 elemento pubblicitario.",
	"compare-not-equal": "{property} deve essere diverso da {compareSource}.",
	"entry-notification-footer": "Hai ricevuto questa e-mail perché selezionato l\u0027opzione Ricevi email notifiche sul form in Cognito Forms.",
	"save-and-resume-copy-link-label": "Copia il tuo link modulo:",
	"entry-confirmation-footer": "Hai ricevuto questa email perché hai completato una transazione con [Name].",
	"required-if-on-or-before": "{property} è richiesto quando {compareSource} è acceso o prima {compareValue}.",
	"string-format": "{property} deve essere formattata come {formatDescription}."
};
